import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { ToasterService } from 'angular2-toaster';

@Injectable()
export class VersionChecker {
  // this will be replaced by actual hash post-build.js
  private currentVersion: string;

  constructor(private http: HttpClient, private toasterService: ToasterService) {
    this.currentVersion = environment['appVersion'];
  }

  /**
   * Checks in every set frequency the version of frontend application
   * @param url
   * @param {number} frequency - in milliseconds, defaults to 10 minutes
   */
  public initVersionCheck(url = environment.baseUrl + '/version.json', frequency = 1000 * 60 * 10) {
    console.log('current version: ', environment['appVersion'] ? environment['appVersion'] : 'DEV');
    setInterval(() => {
      this.checkVersion(url);
    }, frequency);
  }

  /**
   * Will do the call and check if the hash has changed or not
   * @param url
   */
  private checkVersion(url) {
    // timestamp these requests to invalidate caches
    this.http.get(url + '?t=' + new Date().getTime())
      .subscribe(
        (response: any) => {
          // console.log(response.version);
          // console.log(this.currentVersion);
          const version = response.version;
          const versionChanged = this.hasHashChanged(this.currentVersion, version);

          // If new version, do something
          if (versionChanged) {
            console.log('changed version');
            // ENTER YOUR CODE TO DO SOMETHING UPON VERSION CHANGE
            window.location.reload()
          }
          // store the new hash so we wouldn't trigger versionChange again
          // only necessary in case you did not force refresh
          this.currentVersion = version;
        },
        (err) => {
          console.error(err, 'Could not get version');
        }
      );
  }

  /**
   * Checks if hash has changed.
   * This file has the JS hash, if it is a different one than in the version.json
   * we are dealing with version change
   * @param currentVersion
   * @param newVersion
   * @returns {boolean}
   */
  private hasHashChanged(currentVersion, newVersion) {
    if (!currentVersion || newVersion === environment['appVersion']) {
      return false;
    }

    return currentVersion !== newVersion;
  }
}
